module.exports = __webpack_public_path__ + "img/161.3efbdbd8.jpg";